import React from "react";
import { Field, UseFieldConfig } from "react-final-form";
import FormStarRating, { FormStarRatingProps } from "ui/Form/StarRating";

type Props = FormStarRatingProps & UseFieldConfig<unknown[]>;

const StarRatingField: React.FC<Props> = ({
    labelProps,
    fieldGroupProps,
    fieldControlProps,
    inputProps,
    ...fieldProps
}) => {
    return (
        <Field name={inputProps.name} {...fieldProps}>
            {({ input, meta }) => {
                return (
                    <FormStarRating
                        error={!!(meta.error || meta.submitError)}
                        errorMessage={meta.submitError}
                        labelProps={labelProps}
                        fieldGroupProps={fieldGroupProps}
                        fieldControlProps={fieldControlProps}
                        inputProps={Object.assign({}, input, inputProps)}
                    />
                );
            }}
        </Field>
    );
};

export default StarRatingField;
